import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    count: 0,
    userInfo:{}
  },
  mutations: {
    setUser(userInfo){
        state.userInfo = userInfo
    }
  },
  actions: {
    setUser({ commit }, userInfo) {
        commit('setUser', userInfo);
      }
  },
  getters: {
    getUser(state) {
        return state.userInfo;
      }
  }
});